export const SUCCESS_MESSAGE_ACTION = 'messages/SUCCESS_MESSAGE_ACTION'
export const FAILURE_MESSAGE_ACTION = 'messages/FAILURE_MESSAGE_ACTION'
